// Brillenhaus – hält eigene Produktblöcke (Preis, Lagerstatus) beim Variantenwechsel aktuell.
// Horizon liefert beim Wechsel die neu gerenderte Seite im Event mit; Elemente mit data-bh-sync
// werden daraus übernommen.
document.addEventListener('variant:update', (event) => {
  const html = event.detail?.data?.html;
  if (!html) return;
  document.querySelectorAll('[data-bh-sync]').forEach((element) => {
    const next = html.querySelector(`[data-bh-sync="${element.dataset.bhSync}"]`);
    if (next) element.innerHTML = next.innerHTML;
  });
});
